import React from "react";
import { FileText, Globe, Zap, Mail, Webhook } from "lucide-react";
import { FaWhatsapp, FaSalesforce, FaGoogle } from "react-icons/fa";
import { FaMeta } from "react-icons/fa6";
import { SiMysql } from "react-icons/si";

// Icon rows for the Connections Overview screen's Sources/Destinations
// panel (src/pages/connectors/connector/connection-flow.tsx) — plain
// icon + label rows, matching the provided screenshot exactly (not the
// colored-badge style used on the Data Hub Overview screen).
export interface OverviewConnectorRow {
  id: string;
  label: string;
  icon: React.ReactNode;
}

export const OVERVIEW_SOURCE_ROWS: OverviewConnectorRow[] = [
  { id: "csv", label: "CSV", icon: <FileText size={18} className="text-emerald-600" /> },
  { id: "mysql", label: "MySQL", icon: <SiMysql size={18} className="text-sky-700" /> },
  { id: "salesforce", label: "Salesforce", icon: <FaSalesforce size={18} className="text-sky-500" /> },
  { id: "web", label: "Web", icon: <Globe size={18} className="text-blue-500" /> },
  { id: "app_events", label: "App Events", icon: <Zap size={18} className="text-gray-700 dark:text-gray-300" /> },
  { id: "whatsapp", label: "WhatsApp", icon: <FaWhatsapp size={18} className="text-green-500" /> },
];

export const OVERVIEW_DESTINATION_ROWS: OverviewConnectorRow[] = [
  { id: "csv", label: "CSV", icon: <FileText size={18} className="text-emerald-600" /> },
  { id: "meta_ads", label: "Meta Ads", icon: <FaMeta size={18} className="text-blue-600" /> },
  { id: "google_ads", label: "Google Ads", icon: <FaGoogle size={18} className="text-blue-500" /> },
  { id: "web", label: "Web", icon: <Globe size={18} className="text-blue-500" /> },
  { id: "email", label: "Email", icon: <Mail size={18} className="text-blue-500" /> },
  { id: "webhook", label: "Webhook", icon: <Webhook size={18} className="text-orange-500" /> },
];
